import { isProd } from "@/config/common";
import {
  ContentfulLocaleEnum,
  CountryCodeEnum,
  CountryNameEnum,
  CurrencyCodeEnum,
  DomainEnum,
  ElevateCodeEnum,
  LanguageCodeEnum,
  type Market,
  PSPEnum,
  SiteLocaleEnum,
  SiteNameEnum,
} from "./i18n-config";

export const se: Market = {
  psp: PSPEnum.WALLEY,
  flag: "🇸🇪",
  currency: CurrencyCodeEnum.SEK,
  countryCode: CountryCodeEnum.SE,
  countryName: CountryNameEnum.SE,
  languageCode: LanguageCodeEnum.SE,
  locale: `${LanguageCodeEnum.SE}-${CountryCodeEnum.SE}`,
  upperCaseLocale: `${LanguageCodeEnum.SE}-${CountryCodeEnum.SE.toUpperCase()}`,
  contentfulLocale: ContentfulLocaleEnum.SE,
  siteLocale: SiteLocaleEnum.SE,
  elevateMarket: ElevateCodeEnum.SE,
  externalStoreId: "ecom-se",
  bookingMarket: "NGSE",
  walleyStoreCodeB2B: isProd() ? 11445 : 6348,
  walleyStoreCodeB2C: isProd() ? 11444 : 6347,
  searchPathName: "/sok",
  domain: DomainEnum.NGSE,
  imageCdn: isProd()
    ? "https://cdn.nordiskagalleriet.se"
    : "https://media.stage.cdn-norce.tech/1413",
  siteName: SiteNameEnum.SE,
};
